/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
enum ProductSelection {
  ppg = 'PPG',
  sku = 'SKU'
}

// array of non financial segment
const NON_FINANCIAL_SEGMENTS = ['dummy', 'ksa_mw', 'sa_mw', 'sa-mw', 'ksa-mw', 'kr_mw', 'kr-mw'];

const PLANNER_TOGGLES = [
  {
    label: ProductSelection.ppg,
    value: ProductSelection.ppg
  },
  {
    label: ProductSelection.sku,
    value: ProductSelection.sku
  }
];

// constant object to handle the delete sku api in case of DS api fails
const InnovationErrorMessages = {
  delete_sku_error_message: 'Error occured in Innovation Model API'
};

// constant object for summary strip respective module
const SummaryStripModuleObject = {
  value: 0,
  label: '',
  suffix: '',
  children: []
};

// constant object for matomo tracking
const MatomoEventTrackMapObject = {
  track_button_click: {
    event_key: 'track_button_click',
    event_label: 'button-click'
  },
  track_simulate_button_click: {
    event_key: 'track_simulate_button_click',
    event_label: 'simulate-click'
  },
  track_download_button_click: {
    event_key: 'track_download_button_click',
    event_label: 'download-click'
  },
  track_create_scenario_button_click: {
    event_key: 'track_create_scenario_button_click',
    event_label: 'create_scenario-click'
  },
  track_tab_switch: {
    event_key: 'track_tab_switch',
    event_label: 'toggle-tab'
  },
  track_load_saved_scenario_button_click: {
    event_key: 'track_load_saved_scenario_button_click',
    event_label: 'load-saved-scenario-click'
  },
  track_page_view: {
    event_key: 'track_page_view',
    event_label: 'track_page_view'
  }
};

export {
  InnovationErrorMessages, MatomoEventTrackMapObject, NON_FINANCIAL_SEGMENTS,
  PLANNER_TOGGLES, ProductSelection, SummaryStripModuleObject
};

